/**
 * SafeLink Component
 * A wrapper around React Router's Link that checks for unsaved changes before navigating
 */

import React from "react";
import { useUnsavedChanges } from "../contexts/UnsavedChangesContext";

interface SafeLinkProps {
    to: string;
    children: React.ReactNode;
    className?: string;
    onClick?: () => void;
    style?: React.CSSProperties;
}

export const SafeLink: React.FC<SafeLinkProps> = ({
    to,
    children,
    className,
    onClick,
    style,
}) => {
    const { checkAndNavigate } = useUnsavedChanges();

    const handleClick = (e: React.MouseEvent) => {
        e.preventDefault();
        if (onClick) {
            onClick();
        }
        checkAndNavigate(to);
    };

    return (
        <a href={to} onClick={handleClick} className={className} style={style}>
            {children}
        </a>
    );
};
